import React, {Component} from 'react';
import {connect} from 'react-redux';

import {
    Button,
    Row
} from 'reactstrap';
import {Link} from 'react-router';

class CompleteFrame extends Component {
    render() {
        return (
            <div className="animated fadeIn mt-4">
                <Row>
                    <h3>You're all finished!</h3>
                </Row>
                <hr/>
                <p>Thank you for verifying your information and your credit. You made it through the toughest part of the process and now {this.props.tenant_first_name} is all set to apply to listings!</p>
                <p>Again, we want to reiterate that your credit information is secure and is not stored by us. If you have any questions or need to get in touch with us, feel free to get ahold of us via the blue messenger in the bottom right of this page.</p>
                <p>As a reminder, if {this.props.tenant_first_name} is still looking for a home in 30 days, you'll need to come back to this page to re-verify your credit. Don't worry, it won't impact your credit score.</p>
                <hr/>
                <div className="center">
                    <Button color="primary" tag={Link} to="/">Learn more about PolyRents</Button>
                </div>
            </div>
        );
    }
}

const mapStateToProps = (state) => ({
    tenant_first_name: state.guarantor.tenant.first_name
});

export default connect(mapStateToProps)(CompleteFrame);



// WEBPACK FOOTER //
// ./src/containers/guarantor/frames/CompleteFrame.js